var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("span", { staticClass: "text-muted" }, [
        _vm._v("\n      will be posted as:\n      "),
        _c("i", { staticClass: "badge badge-primary" }, [
          _vm._v(_vm._s(_vm.formParamScrapeSt.media_type))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-8" }, [
          _c("div", { staticClass: "col-md-12 profile-info-left" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                { staticClass: "form-group row" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.assetsUrl.length && _vm.files.length == 0
                    ? [
                        _c(
                          "div",
                          { staticClass: "row row-sm" },
                          _vm._l(_vm.assetsUrl, function(imgsrc, idx) {
                            return _c(
                              "div",
                              {
                                key: idx,
                                staticClass:
                                  "col-6 col-sm-4 col-md-3 col-lg-4 col-xl-3"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card card-file",
                                    staticStyle: { width: "250px" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dropdown-file",
                                        staticStyle: { "z-index": "1" }
                                      },
                                      [
                                        _vm._m(1, true),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown-menu dropdown-menu-right"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removeCurrentAssets(
                                                      imgsrc
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Delete")]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text-center" }, [
                                      imgsrc.includes(".jpg") ||
                                      imgsrc.includes(".jpeg")
                                        ? _c("img", {
                                            staticStyle: { width: "100%" },
                                            attrs: { src: imgsrc, alt: "" }
                                          })
                                        : imgsrc.includes(".mp4")
                                        ? _c(
                                            "video",
                                            {
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%",
                                                overflow: "hidden"
                                              },
                                              attrs: { controls: "" }
                                            },
                                            [
                                              _c("source", {
                                                attrs: {
                                                  src: imgsrc,
                                                  type: "video/mp4"
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  ]
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.files.length == 0,
                          expression: "files.length == 0"
                        }
                      ],
                      staticClass: "col-md-12 upload-drop-zone",
                      attrs: { id: "drop-zone" }
                    },
                    [
                      _vm._v(
                        "\n                Drop files anywhere to upload\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm.files.length
                      ? _c(
                          "ul",
                          { staticClass: "upload-list" },
                          _vm._l(_vm.files, function(file) {
                            return _c(
                              "li",
                              { key: file.id, staticClass: "file-list" },
                              [
                                _c("div", { staticClass: "upload-wrap" }, [
                                  _c("div", { staticClass: "file-name" }, [
                                    file.thumb
                                      ? _c("img", {
                                          staticStyle: { width: "30px" },
                                          attrs: { src: file.thumb }
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(file.name) +
                                        "\n                      "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "file-size" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.formatSizes(file.size)) +
                                        "\n                      "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "file-close" }, [
                                    file.error
                                      ? _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(file.error))]
                                        )
                                      : file.success
                                      ? _c("span", [
                                          _c("i", {
                                            staticClass:
                                              "text-success fa fa-check-circle"
                                          })
                                        ])
                                      : file.active
                                      ? _c("span", [_vm._v("active")])
                                      : _c("span"),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "text-warning",
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.$refs.uploadbc.remove(file)
                                            _vm.removeCurrentAssets(
                                              file.data.url
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa fa-trash-o"
                                        })
                                      ]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                file.active || file.progress !== "0.00"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "progress progress-xs progress-striped"
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "progress-bar bg-success",
                                          style: { width: file.progress + "%" },
                                          attrs: { role: "progressbar" }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                file.active || file.progress !== "0.00"
                                  ? _c(
                                      "div",
                                      { staticClass: "upload-process" },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(file.progress) +
                                            "% done\n                    "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _c(
                        "file-upload",
                        {
                          ref: "uploadbc",
                          staticClass: "btn btn-primary",
                          attrs: {
                            "add-index": true,
                            data: _vm.objFilesMessageHandler,
                            "post-action": _vm.uploadUrl,
                            multiple: true,
                            headers: _vm.headers,
                            drop: true,
                            "drop-directory": true,
                            maximum: _vm.maximumUpload,
                            extensions: _vm.extensions
                          },
                          on: {
                            "input-filter": _vm.inputFilter,
                            "input-file": _vm.inputFile
                          },
                          model: {
                            value: _vm.files,
                            callback: function($$v) {
                              _vm.files = $$v
                            },
                            expression: "files"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-plus" }),
                          _vm._v("\n                  Select\n                ")
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12 text-muted" }, [
                    _c(
                      "ul",
                      {
                        staticStyle: {
                          "overflow-x": "scroll",
                          "overflow-y": "hidden",
                          "white-space": "nowrap"
                        }
                      },
                      [
                        _c("li", [
                          _vm._v("Support files: " + _vm._s(_vm.extensions))
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "MaxSize: " + _vm._s(_vm.formatSizes(_vm.size))
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(
                            "Maximum Upload: " +
                              _vm._s(_vm.maximumUpload) +
                              " Files"
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.formParamScrapeSt.media_type == "reels"
                    ? _c("div", { staticClass: "col-md-12" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col" }, [
                            _vm.loading
                              ? _c(
                                  "div",
                                  { staticClass: "mb-3" },
                                  [_c("skeleton")],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.cover_url
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "relative image-preview mb-3"
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "preview",
                                      attrs: {
                                        title: "Lihat Cover",
                                        src: _vm.cover_url
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "remove-image",
                                        attrs: {
                                          title: "Hapus Cover",
                                          type: "button"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.removeProductImage()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        ×\n                      "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "box-image" }, [
                              _c(
                                "label",
                                { staticClass: "btn btn-md btn-success" },
                                [
                                  _c("input", {
                                    ref: "cover_url",
                                    attrs: {
                                      type: "file",
                                      accept: "image/jpg, image/jpeg",
                                      name: "cover_url"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.onFileSelected()
                                      }
                                    }
                                  }),
                                  _vm._v(
                                    "\n                        Pilih File\n                      "
                                  )
                                ]
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "small",
                              {
                                staticStyle: {
                                  color: "#8e8e8e",
                                  "font-weight": "bold"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                      Upload File pastikan jpg, jpeg tidak lebih dari\n                      " +
                                    _vm._s(_vm.formatSizes(_vm.size))
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$refs.uploadbc && _vm.$refs.uploadbc.active == true
                    ? _c("div", { staticClass: "col-md-12" }, [
                        _c(
                          "div",
                          { staticClass: "col-sm-2" },
                          [_c("Skeleton", { attrs: { count: 1 } })],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.formParamScrapeSt.media_type == "story"
                        ? false
                        : true,
                    expression:
                      "formParamScrapeSt.media_type == 'story' ? false : true"
                  }
                ],
                staticClass: "col-md-12"
              },
              [
                _c("div", { staticClass: "form-group row" }, [
                  _c("label", { staticClass: "col-form-label" }, [
                    _vm._v("Caption")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "message-bar" }, [
                    _c("div", { staticClass: "message-inner" }, [
                      _c(
                        "a",
                        {
                          staticClass: "link attach-icon",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.emojiToggle()
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "30px" },
                            attrs: {
                              src: require("@/assets/emoji.png"),
                              alt: ""
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group m-b-30" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-append" },
                          [
                            _c("Emoji", {
                              attrs: {
                                open: _vm.emojiAttr.open,
                                width: _vm.emojiAttr.width,
                                height: _vm.emojiAttr.height,
                                searchLabel: "Search emoji here"
                              },
                              on: { click: _vm.selectedEmoji }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.caption,
                              expression: "caption"
                            }
                          ],
                          ref: "messagebox",
                          style: "width:100%; height:200px;",
                          attrs: { placeholder: "Caption...", required: "" },
                          domProps: { value: _vm.caption },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.caption = $event.target.value
                            }
                          }
                        })
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _vm.files.length
          ? _c("div", { staticClass: "col-md-4" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12" }, [
                _vm.assetsUrl.length
                  ? _c(
                      "div",
                      [
                        _c(
                          "carousel",
                          {
                            attrs: {
                              navigateTo: 0,
                              autoplay: true,
                              paginationEnabled: false,
                              perPage: 1,
                              navigationEnabled: true,
                              centerMode: true,
                              paginationActiveColor: "#00bddc",
                              paginationColor: "#99e8ff"
                            }
                          },
                          _vm._l(_vm.assetsUrl, function(imgSrc, idx) {
                            return _c(
                              "slide",
                              { key: idx, attrs: { "data-index": "0" } },
                              [
                                imgSrc.includes(".jpg") ||
                                imgSrc.includes(".jpeg")
                                  ? _c("img", {
                                      staticStyle: { width: "100%" },
                                      attrs: { src: imgSrc, alt: "" }
                                    })
                                  : imgSrc.includes(".mp4")
                                  ? _c(
                                      "video",
                                      {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                          overflow: "hidden"
                                        },
                                        attrs: { controls: "" }
                                      },
                                      [
                                        _c("source", {
                                          attrs: {
                                            src: imgSrc,
                                            type: "video/mp4"
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  : _c("div", { staticClass: "card" }, [_vm._m(4)]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.caption != "" &&
                          _vm.formParamScrapeSt.media_type != "story"
                            ? true
                            : false,
                        expression:
                          "\n              caption != '' && formParamScrapeSt.media_type != 'story'\n                ? true\n                : false\n            "
                      }
                    ],
                    staticClass: "card",
                    staticStyle: { "margin-top": "10px" }
                  },
                  [
                    _c("div", {
                      staticClass: "card-body",
                      domProps: {
                        innerHTML: _vm._s(_vm.messageFilter(_vm.caption))
                      }
                    })
                  ]
                )
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "col-form-label" }, [
      _vm._v("\n                Attach File\n                "),
      _c("span", { staticClass: "text text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "dropdown-link",
        attrs: { href: "", "data-toggle": "dropdown" }
      },
      [_c("i", { staticClass: "fa fa-ellipsis-v" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("label", { staticClass: "col" }, [
        _vm._v("Cover URL"),
        _c("span", { staticClass: "text text-danger" }, [_vm._v("*")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", { staticClass: "badge badge-dark" }, [_vm._v("Preview")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: { src: require("@/assets/placeholder.jpg") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71472907", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71472907","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/instagram/instagramScheduleOfficial/components/form2.vue
// module id = null
// module chunks = 